import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';

import { Clients } from '../services/globals.service';

@Component({
  selector: 'HomeServices-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.css']
})
export class TermsComponent implements OnInit {

  public clients: Clients = null;
  public clientID: number = 0;

  constructor(_clients: Clients) {
    this.clients = _clients;
    this.clientID = environment.clientID;
  }

  ngOnInit() {
  }

}
